import { NgModule } from '@angular/core';
import { MdbNotificationModule, MdbNotificationService } from 'mdb-angular-ui-kit/notification';
import { AlertService, ToastService, NotificationService} from '../services';

@NgModule({
  imports: [MdbNotificationModule], // Import MdbModalModule here
  providers: [NotificationService, AlertService, ToastService,  MdbNotificationService], // Provide the custom service
})
export class NotificationModule {}